import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SectionFadeIn from "@/components/SectionFadeIn";
import { useTranslation } from 'react-i18next';

const FAQSection = () => {
  const { t } = useTranslation('home');

  const faqItems = t('faq.items', { returnObjects: true }) as Array<{ question: string; answer: string }>;

  return (
    <section className="section-padding bg-secondary">
      <div className="container-max">
        <SectionFadeIn>
          <div className="text-center mb-12">
            <div className="h-1 w-12 bg-brand-yellow mx-auto mb-4" />
            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-3">{t('faq.title')}</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">{t('faq.subtitle')}</p>
          </div>
        </SectionFadeIn>
        <SectionFadeIn delay={0.1}>
          <div className="max-w-3xl mx-auto">
            <Accordion type="single" collapsible className="space-y-3">
              {Array.isArray(faqItems) && faqItems.map((faq, i) => (
                <AccordionItem key={i} value={`faq-${i}`} className="bg-background border border-border rounded-sm px-6">
                  <AccordionTrigger className="text-left text-foreground font-semibold text-sm sm:text-base hover:text-accent transition-colors py-5">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </SectionFadeIn>
      </div>
    </section>
  );
};

export default FAQSection;
